import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import Select from "react-select";

interface AgeCategorySectionProps {
  ageCategoryList: string[];
  selectedAgeCategory: string;
  loadingAgeCategories: boolean;
  onAgeCategorySelect: (ageCategory: string) => void;
  disabled?: boolean;
}

const AgeCategorySection: React.FC<AgeCategorySectionProps> = ({
  ageCategoryList,
  selectedAgeCategory,
  loadingAgeCategories,
  onAgeCategorySelect,
  disabled,
}) => {
  const ageCategoryOptions = ageCategoryList.map((ageCategory) => ({
    value: ageCategory,
    label: ageCategory,
  }));

  return (
    <div className="enrolment-form-section">
      <h6 className="enrolment-section-title">
        <span className="enrolment-section-number">6</span>
        Age Category
      </h6>

      <Row className="g-3">
        <Col xs={12} md={6}>
          <Form.Label className="mb-1 text-muted" style={{ fontSize: 12 }}>
            Age Category *
          </Form.Label>
          {disabled ? (
            <div className="enrolment-readonly-field-wrapper">
              <Form.Control
                readOnly
                value={selectedAgeCategory || "—"}
                style={{ pointerEvents: "none" }}
              />
            </div>
          ) : (
            <Select
              classNamePrefix="react-select"
              options={ageCategoryOptions}
              isLoading={loadingAgeCategories}
              isDisabled={disabled}
              value={
                selectedAgeCategory
                  ? { value: selectedAgeCategory, label: selectedAgeCategory }
                  : null
              }
              onChange={(opt) => opt && onAgeCategorySelect(opt.value)}
              placeholder="Select age category..."
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AgeCategorySection;
